module.exports = __webpack_public_path__ + "img/Thumbnail_ZWF_Kacper_Julia.36476a1c.jpg";